/** @jsxImportSource react */
import { cn } from '@common/lib/clsxm';
import FieldAdapter from '@react/form/components/FieldAdapter';
import { required } from '@react/form/helpers/validation';
import { Button } from '@react/system';
import {
  DATA_HUB_TOC_OPTIONS,
  ROOM_OPTIONS,
} from '@react/widgets/pricingTrend/constants';
import React from 'react';
import { Field, Form } from 'react-final-form';

const PricingTrendForm = ({
  handleSubmit,
  initialFilters,
  locationString = '',
  nearest = false,
  className = '',
  buttonClassName = '',
  buttonText = 'Calculate',
}) => {
  return (
    <div className={cn('px-4 py-5', className)}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={handleSubmit}
        initialValues={initialFilters}
      >
        {({ handleSubmit, submitting, invalid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              data-tp-id='gen-form-2be9dba3-a4d6-4560-bb91-85d01e98c532'
            >
              {/* <FormSpy
                subscription={{
                  values: true,
                }}
                onChange={({ values }) => {
                  handleSubmit(values);
                }}
              /> */}
              <Field
                name='location'
                component={FieldAdapter}
                type='locationSearch'
                label='City name'
                data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                validate={required}
                types={['(cities)']}
                placeholder='Search by city'
                address={locationString}
              />
              {nearest && (
                <p className='mb-4 -mt-2 text-sm '>
                  The closest area for Senior Living Pricing Trends data is:{' '}
                  <span>{locationString}</span>
                </p>
              )}
              <div className='md:flex md:gap-2 md:child:flex-1'>
                <Field
                  name='toc'
                  component={FieldAdapter}
                  type='select'
                  label='Type of care'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  options={DATA_HUB_TOC_OPTIONS}
                />
                <Field
                  name='typeOfRoom'
                  component={FieldAdapter}
                  type='select'
                  label='Type of room'
                  data-tp-id='gen-Field-af18addc-1624-4349-af1f-7e3ac94364ba'
                  validate={required}
                  options={ROOM_OPTIONS}
                />
              </div>
              <Button
                disabled={submitting || invalid}
                className={cn('w-full', buttonClassName)}
                data-tp-id='gen-Button-cb53f138-bb5f-4675-a94e-cf922c046697'
              >
                {buttonText}
              </Button>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

export default PricingTrendForm;
